import { formatMoney, formatNumber } from './helpers';

export const shortSaleStatisticsColumns  = [
  {
    key: 'totalProductsQuantity',
    label: 'salesStatistics.Number of products sold',
    formatter: value => formatNumber(value)
  },
  {
    key: 'totalPrice',
    label: 'salesStatistics.Product cost',
    formatter: (value, currency) => formatMoney(value, currency)
  },
  {
    key: 'totalCost',
    label: 'salesStatistics.Cost of goods sold',
    formatter: (value, currency) => formatMoney(value, currency)
  },
  {
    key: 'totalProfit',
    label: 'salesStatistics.Sales profit',
    formatter: (value, currency) => formatMoney(value, currency)
  }
];

export const getDailySalesColumns = () => [
  { key: 'date', titleKey: 'statistic.date', flex: '0 0 18%' },
  { key: 'quantity', titleKey: 'salesStatistics.Number of products sold', flex: '0 0 12%' },
  { key: 'value', titleKey: 'salesStatistics.Product cost', flex: '0 0 15%' },
  { key: 'cost', titleKey: 'salesStatistics.Cost of goods sold', flex: '0 0 15%' },
  { key: 'profit', titleKey: 'salesStatistics.Sales profit', flex: '0 0 15%' }
];

export const getPopularProductsSalesColumns = () => [
  { key: 'productName', titleKey: 'salesStatistics.Product name', flex: '0 0 15%' },
  { key: 'brand', titleKey: 'salesFilters.Brand', flex: '0 0 10%' },
  { key: 'category', titleKey: 'salesStatistics.Category / subcategory', flex: '0 0 20%' },
  { key: 'quantity', titleKey: 'salesStatistics.Sales for the period', flex: '0 0 9%' },
  { key: 'value', titleKey: 'salesStatistics.Price', flex: '0 0 9%' },
  { key: 'cost', titleKey: 'salesStatistics.Cost price', flex: '0 0 9%' },
  { key: 'profit', titleKey: 'salesStatistics.Profit', flex: '0 0 9%' },
];

export const getEmployeesSalesColumns = () => [
  { key: 'employee', titleKey: 'salesStatistics.Master', flex: '0 0 30%' },
  { key: 'salesCount', titleKey: 'salesStatistics.Number of products sold', flex: '0 0 12%' },
  { key: 'amount', titleKey: 'salesStatistics.Product cost', flex: '0 0 15%' },
  { key: 'cost', titleKey: 'salesStatistics.Cost of goods sold', flex: '0 0 15%' },
  { key: 'profit', titleKey: 'salesStatistics.Profit', flex: '0 0 15%' }
]